import React from 'react'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

import clasroom from "../images/Class Room.jpg";
import CoumputerLab from "../images/Computer lab.jpg";
import Dptlab from "../images/dpt lab1.jpg";
import dptlab2 from "../images/dpt lab-3.jpg";

import Dptlab3 from "../images/DPT Lab 4.jpg";
import ECGlab from "../images/ECG Lab 2.jpg";
import ecglabmurshidabad from "../images/ECG lab 1.jpg";
import Entrance from "../images/Entrance.jpg";



function ParamedicalPhoto() {
    return (
        <div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={clasroom} className="card-img-top" alt="classroom"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Class Room </h5>



                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={CoumputerLab} className="card-img-top" alt="CoumputerLab"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Coumputer Lab </h5>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={Dptlab} className="card-img-top" alt="Dptlab" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">DPT Lab 1 </h5>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={dptlab2} className="card-img-top" alt="dptlab2"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >DPT Lab 2                               </h5>


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={Dptlab3} className="card-img-top" alt="Dptlab3"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">DPT Lab 3 </h5>



                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={ECGlab} className="card-img-top" alt="ECGlab"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">ECG Lab </h5>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={ecglabmurshidabad} className="card-img-top" alt="ecglabmurshidabad"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">ECG Lab 1 </h5>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={Entrance} className="card-img-top" alt="Entrance"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Entrance                               </h5>


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    )
}

export default ParamedicalPhoto